import type { DragEndEvent } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import { isEqual } from 'lodash-es';
import { useEffect, useMemo, useState } from 'react';

export const useSortOrder = <T extends { id: string }>(dataSource: T[]) => {
  const [data, setData] = useState(dataSource);

  const onDragEnd = ({ active, over }: DragEndEvent) => {
    if (active.id !== over?.id) {
      setData((prev) => {
        const activeIndex = prev.findIndex((i) => i.id === active.id);
        const overIndex = prev.findIndex((i) => i.id === over?.id);
        return arrayMove(prev, activeIndex, overIndex);
      });
    }
  };

  const hasDataIndexChanged = useMemo(() => {
    const initialDataIds = dataSource.map((item) => item.id);
    const currentDataIds = data.map((item) => item.id);
    return !isEqual(initialDataIds, currentDataIds);
  }, [dataSource, data]);

  useEffect(() => {
    setData(dataSource);
  }, [dataSource]);

  return { sortedData: data, onDragEnd, hasDataIndexChanged };
};
